import React, { useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, useTheme } from "@mui/material";
import { fontColor } from "../../../constants/ColorSets";
import { RuleUnitState } from "../../../types/models/RuleUnitState";
import { AppState } from "../../../redux/store";
import AppCard from "../../../components/AppCard";
import RuleOfWeekItem from "./RuleOfWeekItem";
import { fetchError, getRulesOfWeek, postUserRuleOfTheWeeks } from "../../../redux/actions";
import { RuleOfWeek } from "../../../types/models/RuleOfWeek";

export default function RuleOfWeekCard() {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { paragraphId } = useParams();
  const ruleUnitState = useSelector<AppState, RuleUnitState>((state) => state.ruleUnit);

  const getRuleIdFromRuleInstanceId = (ruleInstanceId: string) => {
    const ruleInstance = (ruleUnitState.baseContentRevisionDetails ?? [])
      .concat(ruleUnitState.baseSupportDocumentContentRevisionDetails ?? [])
      .flatMap((detail) => detail.RuleInstances)
      .find((rule) => rule?.RuleInstanceId === ruleInstanceId);

    return ruleInstance?.RuleId;
  };

  const getDisplayRulesOfWeek = useCallback(() => {
    const onViewParagraph = (ruleOfWeek: RuleOfWeek) => {
      const ruleId = getRuleIdFromRuleInstanceId(ruleOfWeek.RuleInstanceId);
      if (ruleId) {
        dispatch(
          postUserRuleOfTheWeeks(ruleOfWeek.Id, (result) => {
            if (result) {
              dispatch(getRulesOfWeek(()=> {
                navigate(`/rules/${ruleId.toString()}/${ruleOfWeek.ParagraphId}`);
              }))
            }
          })
        );
      } else {
        dispatch(fetchError("The Rule of the Week could not be found."));
      }
    };

    if (ruleUnitState.rulesOfWeek && ruleUnitState.rulesOfWeek.length > 0) {
      return (
        <Box>
          {ruleUnitState.rulesOfWeek?.map((ruleOfWeek) => (
            <RuleOfWeekItem
              key={ruleOfWeek.ParagraphId}
              ruleOfWeek={ruleOfWeek}
              isSelected={paragraphId === ruleOfWeek.ParagraphId}
              onViewParagraph={onViewParagraph}
            />
          ))}
        </Box>
      );
    }
  }, [
    ruleUnitState.rulesOfWeek,
    ruleUnitState.baseContentRevisionDetails,
    ruleUnitState.baseSupportDocumentContentRevisionDetails,
  ]);

  return (
    <Box component="section" id="alerts">
      <AppCard
        contentStyle={{ px: 0 }}
        title={
          <Box
            display="flex"
            gap={0.5}
            p={0.5}
            alignItems="center"
            sx={{
              color: theme.card.headerTextColor,
              fontWeight: 600,
              fontSize: 18,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
              margin: 0,
              display: "flex",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Typography variant="h5" component="h3">
                Rule of the Week
              </Typography>
            </Box>
          </Box>
        }
        headerStyle={{ backgroundColor: fontColor.grayBackground }}
      >
        <Box>{getDisplayRulesOfWeek()}</Box>
      </AppCard>
    </Box>
  );
}
